// Preco do acesso vitalicio num lugar so - e o unico numero que muda quando
// a oferta de lancamento acabar. O backend tem a copia dele em
// mentoria-api/api/_lib/saas-products.js (PLANS.lifetime.amount), que e quem
// realmente cobra: o valor daqui e so vitrine.
export const LIFETIME_PRICE = 197;
export const LIFETIME_INSTALLMENTS = 12;

// Preco da Mentoria num lugar so - o backend tem a copia dele em
// mentoria-api/api/_lib/mentoria-pricing.js (getMentoriaAmount), que e quem
// realmente cobra: o valor daqui e so vitrine. Promocao relampago ate o fim do
// domingo 18/10/2026 (Brasilia); depois o preco volta sozinho para R$ 397, sem
// deploy (front e back usam a mesma data de corte: 19/10/2026 00:00 -03:00).
export const MENTORIA_PROMO_PRICE = 197;
export const MENTORIA_REGULAR_PRICE = 397;
export const MENTORIA_FULL_PRICE = 397; // "de R$ 397" riscado, so aparece durante a promocao
export const MENTORIA_PROMO_ENDS_AT = Date.parse("2026-10-19T00:00:00-03:00");
export const MENTORIA_PROMO_LABEL = "domingo, 18/10";

export const isMentoriaPromoActive = (now = Date.now()) => now < MENTORIA_PROMO_ENDS_AT;
export const getMentoriaPrice = (now = Date.now()) => (isMentoriaPromoActive(now) ? MENTORIA_PROMO_PRICE : MENTORIA_REGULAR_PRICE);

export const SUBSCRIPTION_PLANS = {
  free: {
    id: "free",
    legacyIds: [],
    name: "Plano Gratuito",
    price: 0,
    label: "R$ 0",
    description: "Todas as ferramentas abertas da Central QA para você explorar a plataforma sem assinatura.",
    features: [
      "Planner QA completo",
      "Bug Report completo",
      "Quality Gate completo",
      "Roadmap de carreira completo",
    ],
    productIds: [],
  },
  starter: {
    id: "starter",
    legacyIds: ["pro"],
    name: "Starter",
    price: 9.9,
    label: "R$ 9,90/mês",
    description: "Para transformar requisitos em artefatos de QA com IA e estudar com a camada inicial do ecossistema.",
    features: [
      "Tudo do plano gratuito",
      "E-book Manual do QA Iniciante",
      "Matriz de casos de teste com IA",
      "Gerador de testes com IA",
      "Histórico, edição e exportações",
    ],
    productIds: ["test-generator", "test-case-sheet"],
  },
  pro: {
    id: "pro",
    legacyIds: ["team"],
    name: "PRO",
    price: 29.9,
    label: "R$ 29,90/mês",
    description: "Para quem quer a camada mais completa, com automação inicial, biblioteca ampliada e recursos premium do ecossistema.",
    features: [
      "Tudo do Starter",
      "Biblioteca interna ampliada",
      "Starter de automação e CI",
      "Checklist pré-deploy com IA",
      "Histórico estendido",
      "Prioridade em novas ferramentas",
      "Apoio ampliado com comunidade e materiais",
    ],
    productIds: ["test-generator", "test-case-sheet", "pre-deploy-checklist", "automation-plan"],
  },
  // Pagamento unico (Mercado Pago Checkout Pro, mesmo meio da mentoria e da
  // revisao de curriculo) que libera exatamente o mesmo conjunto do PRO, para
  // sempre, mais a biblioteca de e-books completa. Nao e assinatura: nao
  // renova, nao tem o que cancelar.
  lifetime: {
    id: "lifetime",
    legacyIds: ["vitalicio"],
    name: "Vitalício",
    price: LIFETIME_PRICE,
    label: `R$ ${LIFETIME_PRICE.toFixed(2).replace(".", ",")}`,
    priceNote: `pagamento único · até ${LIFETIME_INSTALLMENTS}x no cartão`,
    oneTime: true,
    description:
      "Pague uma vez e tenha tudo que existe no site hoje — e o que for lançado depois — sem mensalidade e sem renovação.",
    features: [
      "Tudo do PRO, para sempre",
      "Biblioteca de e-books completa",
      "Gerador de Testes, Matriz de Casos, Guia de Release e Starter de Automação",
      "Todas as ferramentas novas do site, sem custo extra",
      "Sem mensalidade, sem renovação e sem cancelamento",
      "Comunidade e materiais de apoio",
    ],
    productIds: ["test-generator", "test-case-sheet", "pre-deploy-checklist", "automation-plan"],
  },
};

// Ordem de "quanto libera". Usada para decidir upgrade x downgrade e para
// checar se um plano cobre o requisito de outro.
export const PLAN_RANK = {
  free: 0,
  starter: 1,
  pro: 2,
  lifetime: 3,
};

// Planos que liberam recurso pago. Serve de fonte unica pros varios
// `["starter", "pro"].includes(...)` espalhados pelas telas - era ali que
// um plano novo passava despercebido e o usuario ficava sem acesso.
export const PAID_PLAN_IDS = ["starter", "pro", "lifetime"];

export function isPaidPlanId(value) {
  return PAID_PLAN_IDS.includes(normalizePlanId(value));
}

// Pagamento unico nao tem assinatura pra cancelar nem cobranca recorrente.
export function isOneTimePlanId(value) {
  return Boolean(SUBSCRIPTION_PLANS[normalizePlanId(value)]?.oneTime);
}

export const INCLUDED_COMMUNITY_LINKS = [
  {
    label: "Telegram",
    href: "https://t.me/qainiciantechat",
  },
  {
    label: "GitHub",
    href: "https://github.com/Srjordao",
  },
];

export const PAID_PRODUCTS = [
  {
    id: "test-generator",
    path: "/produtos/gerador-testes",
    title: "Gerador de Testes com IA",
    shortTitle: "Gerador de Testes",
    plan: "starter",
    description: "Transforme requisitos e regras de negócio em cenários, ideias de cobertura e direcionamento inicial de testes.",
    outcome: "Uma base de cenários e direções de validação para acelerar estudo, documentação e revisão com o time.",
    example: "Exemplo: assinatura com cobrança recorrente, liberação de benefícios e bloqueio de usuários sem pagamento.",
    sequence: 1,
    nextStep: "Depois use a Matriz de Casos para detalhar a execução.",
    primary: true,
  },
  {
    id: "test-case-sheet",
    path: "/produtos/planilha-casos",
    title: "Matriz de Casos com IA",
    shortTitle: "Matriz de Casos",
    plan: "starter",
    description: "Transforme a estratégia em uma tabela de casos com prioridade, passos, resultados esperados e status inicial.",
    outcome: "Tabela pronta para usar em Sheets, Excel, Notion, Jira ou outra ferramenta de acompanhamento.",
    example: "Exemplo: login, checkout, aprovação de pagamento, trilhas de erro e cenários de borda.",
    sequence: 2,
    nextStep: "Depois passe pelo Guia de Release para fechar a validação final.",
  },
  {
    id: "pre-deploy-checklist",
    path: "/produtos/checklist-pre-deploy",
    title: "Guia de Release com IA",
    shortTitle: "Guia de Release",
    plan: "pro",
    description: "Monte uma revisão pre-release com smoke, rollback, observabilidade, ambiente e comunicação.",
    outcome: "Checklist operacional para reduzir risco antes de publicar uma entrega em produção.",
    example: "Exemplo: nova assinatura liberando recursos premium com mudança de acesso, histórico e exportação.",
    sequence: 3,
    nextStep: "Se precisar estruturar automação, avance para o Starter de Automação.",
  },
  {
    id: "automation-plan",
    path: "/produtos/automacao-ci",
    title: "Starter de Automação",
    shortTitle: "Starter de Automação",
    plan: "pro",
    description: "Gere a base inicial de um projeto de automação com framework, autenticação, CI e organização técnica.",
    outcome: "Pacote inicial para acelerar a implantação da automação e alinhar o projeto ao cenário real do produto.",
    example: "Exemplo: projeto Cypress com login, pipeline, variáveis e estrutura de testes e2e.",
    sequence: 4,
    nextStep: "Use em sequência depois de definir estratégia, matriz e release.",
  },
];

export function normalizePlanId(value) {
  const raw = String(value || "").toLowerCase();
  if (SUBSCRIPTION_PLANS[raw]) return raw;

  const normalized = Object.values(SUBSCRIPTION_PLANS).find((plan) => plan.legacyIds.includes(raw));
  return normalized?.id || "free";
}

export function planCanAccess(planId, productId) {
  const normalizedPlan = normalizePlanId(planId);
  if (!normalizedPlan || !productId) return false;
  return SUBSCRIPTION_PLANS[normalizedPlan]?.productIds.includes(productId) || false;
}
